import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { RouterOutputs } from "@/trpc";

export type OrgPendingTimeEntry =
  RouterOutputs["timeEntry"]["getPendingTimeEntriesForOrg"][number];

export interface TimeEntryFilters {
  weekKey?: string;
  facilityId?: string;
  providerId?: string;
}

/**
 * Hook to fetch pending time entries for organization review.
 * Returns entries in pending_org_review status for the selected business unit.
 */
export function usePendingTimeEntries(
  organizationBusinessUnitId: string | undefined,
  filters: TimeEntryFilters = {},
) {
  const trpc = useTRPC();

  const {
    data: entries,
    isLoading,
    error,
    refetch,
  } = useQuery(
    trpc.timeEntry.getPendingTimeEntriesForOrg.queryOptions(
      {
        organizationBusinessUnitId: organizationBusinessUnitId!,
        weekKey: filters.weekKey,
        facilityId: filters.facilityId,
        providerId: filters.providerId,
      },
      {
        enabled: !!organizationBusinessUnitId,
      },
    ),
  );

  return {
    entries: entries ?? [],
    isLoading,
    error,
    refetch,
  };
}
